export default __webpack_public_path__ + "static/media/telegram.8a038cd9.svg";